export default "__VITE_ASSET__$6Eu4Trf__"